<template>
    <div class="af3-shortcodes-site-map-component" v-html="decodedMapCode" ref="mapContainer"></div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive, computed } from 'vue';


export default defineComponent({
    components: { },
   
    props: {
        map_code: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        resources_url: {
            type: String,
            required: true
        }
    },

    setup(props) {
        const mapContainer = ref(null);
        
        const decodedMapCode = computed(() => {
            if (!props.map_code) return '';
            
            // First replace the problematic \&quot; patterns with actual quote marks
            let decoded = props.map_code
                .replace(/\\&quot;/g, '"')
                .replace(/&quot;/g, '"')
                .replace(/\\/g, '');
            
            // Additional HTML entity decoding if needed
            const textarea = document.createElement('textarea');
            textarea.innerHTML = decoded;
            
            return textarea.value;
        });
        
        onMounted(() => {
            // Resize iframe after it loads
            if (mapContainer.value) {
                const iframe = mapContainer.value.querySelector('iframe');
                if (iframe) {
                    iframe.style.width = '100%';
                    iframe.style.height = '600px'; // Set a reasonable default height
                    iframe.style.border = 'none';
                    
                    iframe.onload = () => {
                        // Attempt to adjust height based on content if possible
                        try {
                            iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
                        } catch (e) {
                            // Cross-origin iframes cannot be measured
                        }
                    };
                }
            }
        });
               
        return {
            decodedMapCode,
            mapContainer
        };
    },
});
</script>

